import styles from "./styles.module.scss";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";
import img3 from "./img/img3.png";
import img4 from "./img/img4.png";

import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "1", // ?
    displayValue: "Fewer than 20 mins",
    emoji: img1,
  },
  {
    value: "2",
    displayValue: "20-60 mins",
    emoji: img2,
  },
  {
    value: "3",
    displayValue: "1-2 hours",
    emoji: img3,
  },
  {
    value: "4",
    displayValue: "More than 2 hours",
    emoji: img4,
  },
];
export const WalkingSpendTime = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.walkingSpendTime, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>How much time do you spend walking on a typical day?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
